import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

const LANGUAGE_STORAGE_KEY = 'runcoach_lang';
const SUPPORTED_LANGUAGES = ['en', 'fr'];

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

function normalizeLanguage(lng) {
  if (!lng) return null;
  const lower = String(lng).toLowerCase();
  if (lower.startsWith('fr')) return 'fr';
  if (lower.startsWith('en')) return 'en';
  return null;
}

function getInitialLanguage() {
  // Persisted user choice (preferred)
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    const normalizedStored = normalizeLanguage(stored);
    if (normalizedStored) return normalizedStored;

    // Migration from older key used by i18next examples / older code
    const legacy = localStorage.getItem('i18nextLng');
    const normalizedLegacy = normalizeLanguage(legacy);
    if (normalizedLegacy) {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLegacy);
      return normalizedLegacy;
    }
  } catch {
    // ignore (e.g. storage blocked)
  }

  // Optional: use browser language as a sensible default
  const normalizedNavigator = normalizeLanguage(
    typeof navigator !== 'undefined' ? navigator.language : null
  );
  return normalizedNavigator || 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
